<template>
  <div class="m-card-videp-wrapper" v-scroll-in-view-once="scrollIn">
    <div class="m-spinner" v-show="!error && !videoLoaded">
      <img :src="loading">
    </div>
    <video
      :src="presrc"
      :class="['m-card-video', {'paused': paused}]"
      ref="video"
      @click="play"
      :controls="isIPhone"
      v-show="!error && videoLoaded"
      v-scroll-out-view="scrollOut"
    >
    </video>
    <div v-if="error" class="c-va-m"><img :src="icons.del"> <span>[视频资源]加载失败</span> <span @click="reload" class="c-blue">重新加载</span></div>
    <div class="firstFrame" v-show="canvasSupported && beforePlay && !error" @click="play">
      <canvas ref='canvas'></canvas>
      <div class="m-card-video-controls">
        <span class="m-card-video-dutation fz13" v-show="!isIPhone && duration">{{duration}}</span>
        <img :src="icons.pause">
      </div>
    </div>
    <div class="firstFrame" v-show="videoLoaded && (paused || ended) && !isIPhone" @click="play">
      <div class="m-card-video-controls">
        <img :src="icons.pause">
      </div>
    </div>
  </div>
</template>

<script>
import iconPause from '@/assets/icons/pause.png'
import iconDel from '@/assets/icons/icon-del.png'
import hhkjsq from '@/common/hhkjsq.js'
import scrollInViewOnce from '@/directive/onceScrollInView'
import scrollOutView from '@/directive/scrollOutView'
import {canvasSupported} from '@/utils/index'
import loading from '@/assets/images/loading.gif'

const {isAndroid, isIPhone} = hhkjsq
export default {
  directives: {
    scrollInViewOnce,
    scrollOutView
  },
  props: ['src'],
  data () {
    return {
      paused: true,
      ended: false,
      beforePlay: false,
      duration: 0,
      presrc: '',
      error: false,
      icons: {
        pause: iconPause,
        del: iconDel
      },
      isAndroid: isAndroid,
      isIPhone: isIPhone,
      canvasSupported: canvasSupported,
      videoLoaded: false,
      loading: loading
    }
  },
  methods: {
    play () {
      this.beforePlay = false
      if (this.paused || this.ended) {
        this.paused = false
        this.ended = false
        this.$refs.video.currentTime = 0
        return this.$refs.video.play()
      }
      this.paused = true
      return this.$refs.video.pause()
    },
    handleDuration (time) {
      if (!time || time === Infinity || time <= 1) { return false }
      var dura = Math.floor(Number(time))
      var min = Math.floor(dura / 60)
      var sec = dura - min * 60
      min = min <= 9 ? '0' + min : min
      sec = sec <= 9 ? '0' + sec : sec
      return [min, sec].join(':')
    },

    scrollIn () {
      this.presrc = this.src
      this.$refs.video.addEventListener('loadedmetadata', () => {
        this.duration = this.handleDuration(this.$refs.video.duration)
      })
      this.$refs.video.addEventListener('error', () => {
        this.error = true
      })
      this.$refs.video.addEventListener('loadeddata', () => {
        this.videoLoaded = true
        if (isIPhone) {
          return
        }
        this.drawFirstFrame()
      })
      this.$refs.video.addEventListener('ended', () => {
        this.ended = true
      })
      if (isIPhone) {
        this.videoLoaded = true
        this.drawFirstFrame()
      }
    },

    reload () {
      this.error = false
      this.ended = false
      this.videoLoaded = false
      this.presrc = this.src
      this.$refs.video.src = this.src
    },

    scrollOut () {
      this.paused = true
      this.$refs.video.pause()
    },

    drawFirstFrame () {
      if (this.beforePlay) {
        this.beforePlay = false
        return
      }
      let canvas = this.$refs.canvas
      let video = this.$refs.video
      var ctx = canvas.getContext('2d')
      ctx.fillStyle = '#000'
      ctx.fillRect(0, 0, canvas.width, canvas.height)
      ctx.drawImage(video, 0, 0, canvas.width, canvas.height)
      this.beforePlay = true
    }
  }
}
</script>

<style scoped>
canvas,.firstFrame{position: absolute;left: 0;top: 0;width: 100%;height: 100%;}
canvas{z-index: 9;}
</style>



// WEBPACK FOOTER //
// cardVideo.vue?3cf0e71c